import { useEffect } from "react";

import { useNavigate, useRouterState } from "@tanstack/react-router";

import { NAVIGATION_PATHS } from "@constants/navigation";

import { useMe } from "@hooks/queries/use-me";

/**
 * Role-aware landing redirect (MDRS-157).
 *
 * The app's default post-login route is `/report-studio`. Providers have their
 * own portal and can't use the expert app, so once `/me` resolves we send them
 * from an expert "home" route to their Requests list.
 *
 * Referrers are NOT redirected — they get a doctor-style sidebar and use Report
 * Studio directly (they only see Report Studio + My Companion), so `/report-studio`
 * is a valid destination for them.
 *
 * Only exact "home" routes are redirected, so deep links are left alone.
 * Renders nothing; mounted once inside the protected layout.
 */
const REDIRECT_FROM = new Set<string>([
  NAVIGATION_PATHS.REPORT_STUDIO,
  NAVIGATION_PATHS.DASHBOARD,
]);

const HOME_BY_USER_TYPE: Record<string, string> = {
  provider: NAVIGATION_PATHS.PROVIDER_REQUESTS,
};

export const RoleLanding = () => {
  const { data: me } = useMe();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    const home = HOME_BY_USER_TYPE[me?.user?.user_type ?? ""];
    if (home && REDIRECT_FROM.has(pathname)) {
      navigate({ to: home, replace: true });
    }
  }, [me, pathname, navigate]);

  return null;
};
